import { useNotificationSignalR } from '../hooks/use-notification-signal-r';
import React, { createContext, useContext } from 'react';

interface WebSocketContextType {
  isConnected: boolean;
  lastMessage: MessageEvent | null;
  subscribe?: (methodName: string, callback: (...args: any[]) => void) => void;
  unsubscribe?: (methodName: string, callback: (...args: any[]) => void) => void;
}

const WebSocketContext = createContext<WebSocketContextType | undefined>(undefined);

interface WebSocketProviderProps {
  children: React.ReactNode;
  url: string;
}

export const WebSocketProvider: React.FC<WebSocketProviderProps> = ({ children, url }) => {
  const { isConnected, lastMessage, subscribe, unsubscribe } = useNotificationSignalR(url);

  return (
    <WebSocketContext.Provider value={{ isConnected: isConnected, lastMessage, subscribe, unsubscribe }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocketContext = (): WebSocketContextType => {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error('useWebSocketContext must be used within a WebSocketProvider');
  }
  return context;
};
